import { render } from "./FeatherLockSvg.vue?vue&type=template&id=45e13d44"
const script = {}
script.render = render

export default script